import { get, flowRight } from 'lodash';

import {
  getLayoutName,
  SEO_LAYOUT_TYPE_FALLBACK,
  POST_LIST_COMPONENT_MASONRY,
} from '@wix/communities-blog-client-common';
import { connect } from '../components/runtime-context';
import {
  getLayoutType,
  isMasonryLayoutSupported,
} from '../selectors/layout-selectors';

import { getSection } from '../selectors/section-selectors';
import { getLayoutConfig } from '../services/layout-config';
import withHocName from './with-hoc-name';

const mapRuntimeToProps =
  (fallbackEnabled) =>
  (state, { section, layoutType, mobileLayoutType }) => {
    section = section || getSection(state, fallbackEnabled);
    layoutType = layoutType || getLayoutType(state, section);
    mobileLayoutType = mobileLayoutType || getLayoutType(state, section, true);

    if (
      !isMasonryLayoutSupported(state) &&
      get(getLayoutConfig(layoutType), 'listComponentName') ===
        POST_LIST_COMPONENT_MASONRY
    ) {
      layoutType = SEO_LAYOUT_TYPE_FALLBACK;
    }

    return {
      section,
      layoutType,
      mobileLayoutType,
      layoutName: getLayoutName(layoutType),
      mobileLayoutName: getLayoutName(mobileLayoutType),
    };
  };

// prettier-ignore
export default function withLayoutProps({ fallbackEnabled = true } = {}) {
  return flowRight(
    connect(mapRuntimeToProps(fallbackEnabled)),
    withHocName('WithLayoutProps')
  );
}
